import i18n from 'src/lib/i18n/i18n';
import View from '@play-co/timestep-core/lib/ui/View';
import { Feature } from 'src/replicant/analytics';
import PopupMatch2Base, { PopupMatch2BaseInitOptions } from './PopupMatch2Base';
import { Match2RewardsPanel } from './Match2RewardsPanel';
import Match2PopupSubHeader from './Match2PopupSubHeader';
import sounds from 'src/lib/sounds';
import { Match2Reward } from 'src/replicant/match2/rewards/match2-rewards.ruleset';

interface PopupMatch2GrantRewardsInitOptions extends PopupMatch2BaseInitOptions {
  rewards: Match2Reward[];
  title?: string;
  sound?: string;
  stars?: number;
  noGrantAnimation?: boolean;
  tracking?: {
    feature: string;
    $subFeature: string;
  };
}

export default class PopupMatch2GrantRewards extends PopupMatch2Base {
  private rewards: Match2RewardsPanel;
  private noAnimation = false;
  private stars?: number;

  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      height: 580,
      title: {
        type: 'banner',
        color: 'red',
        textSize: 42,
      },
      cta: {
        localeText: () => i18n('match2.dailyBonus.claim'),
        width: 300,
        positioning: 'inside',
        onClick: async () => {
          this.setInteractivity(false);
          if (!this.noAnimation) {
            // Dismiss the popup earlier so we can see the new animations
            void this.fadeOut();
            await this.rewards.grantRewards(this.root, this.stars);
          }
          opts.close();
        },
      },
      tracking: {
        feature: Feature.MATCH2._,
        $subFeature: Feature.MATCH2.GRANT_REWARDS_POPUP,
      },
      zIndex: 10000,
    });

    // FIXME: This should not be needed, the base class SHOULD set the height of the text!
    this.title!.updateOpts({
      height: this.titleBanner!.style.height - 22,
      y: this.titleBanner!.style.height * 0.5 - 5,
      centerOnOrigin: true,
    });

    new Match2PopupSubHeader({
      superview: this.panel,
      x: this.panel.style.width * 0.5,
      y: 105,
      localeText: () => i18n('match2.dailyBonus.rewards'),
    });

    this.rewards = new Match2RewardsPanel({
      superview: this.panel,
      x: this.panel.style.width * 0.5,
      y: this.panel.style.height * 0.5 + 5,
      height: 280,
      itemSize: 100,
      itemPadding: 10,
      itemOffsetX: 10,
      itemOffsetY: 10,
      itemLabelOffsetX: -10,
      itemLabelOffsetY: -10,
    });
  }

  public async init({
    rewards,
    title,
    sound,
    useClickOutside,
    tracking,
    noGrantAnimation,
    stars,
  }: PopupMatch2GrantRewardsInitOptions) {
    this.setTitleText(() =>
      i18n(title ?? 'match2.ui.levelRewardsTitle').toLocaleUpperCase(),
    );
    super.init({ useClickOutside });
    this.stars = stars;
    this.rewards.setRewards(rewards);
    this.noAnimation = !!noGrantAnimation;
    if (sound) sounds.sfx.play(sound);
    if (tracking) {
      this.buttonCta!.tracking = {
        feature: tracking.feature,
        $subFeature: `${tracking.$subFeature}-cta`,
      };
    }
  }
}
